<svelte:options />

<script lang="ts">
  import type { A11yLabels, Feature, FeatureGroup } from './sidebar.types';
  import FeatureGroupComponent from './sidebar-feature-group.nested.svelte';
  import SubFeaturesComponent from './sidebar-sub-features.nested.svelte';
  import { isSidebarOpen, toggleSidebar } from './sidebar-service';

  export let data: FeatureGroup[] = [];
  export let a11yLabels: A11yLabels;

  let expandedGroup: string | undefined;
  let expandedSubGroup: Feature | undefined;

  function handleGroupClick(code: string) {
    // opens the menu if at the time of the click on a FeatureGroup this one was closed
    const open = $isSidebarOpen;
    if (!open) {
      toggleSidebar();
    }

    if (open && expandedGroup === code) {
      expandedGroup = undefined;
    } else {
      expandedGroup = code;
    }
  }

  function handleFeatureClick(event?: CustomEvent<Feature>) {
    if (event?.detail) {
      if (expandedSubGroup && expandedSubGroup.code === event.detail.code) {
        expandedSubGroup = undefined;
      } else {
        expandedSubGroup = event.detail;
      }
    } else {
      expandedSubGroup = undefined;
    }
  }
</script>

{#if data?.length}
  <div class="mc-sidebar-section">
    <ul
      class={expandedSubGroup && $isSidebarOpen ? 'is-hidden' : 'is-visible'}
      aria-hidden={expandedSubGroup && $isSidebarOpen}
    >
      {#each data as featureGroup}
        <li on:click={() => handleGroupClick(featureGroup.code)}>
          <FeatureGroupComponent
            {featureGroup}
            expand={expandedGroup === featureGroup.code}
            {a11yLabels}
            on:feature-click={(event) => handleFeatureClick(event)}
          />
        </li>
      {/each}
    </ul>
    {#if expandedSubGroup && $isSidebarOpen}
      <SubFeaturesComponent
        data={expandedSubGroup}
        {a11yLabels}
        on:back-click={() => handleFeatureClick()}
      />
    {/if}
  </div>
{/if}

<style lang="scss">
  @import './sidebar-variables';

  .mc-sidebar-section {
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: flex-start;
    min-height: 38px;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-y: overlay;
    padding: 1px 0px;

    ul,
    li {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
      width: 100%;
    }

    ul {
      align-items: start;
      flex-direction: column;
      justify-content: center;

      li {
        flex-direction: column;
        box-sizing: border-box;
        margin: 4px 0px;

        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }

      &.is-hidden {
        @include transition(margin-left 300ms ease-in-out);
        margin-left: -320px;
        opacity: 0;
      }

      &.is-visible {
        @include transition(margin-left 300ms ease-in-out);
        margin-left: 0;
      }
    }
  }
</style>
